module.exports = __webpack_public_path__ + "fonts/Muli-Light.9a298b5f.woff";